import { LOCALES } from "~/constants/i18n";
import { AzureConfigurator } from "~/services/azure-configurator/azure-configurator";
import { ClientConfig } from "~/services/azure-configurator/types";

export const getBloomreachCatalogsAzureKeys = (
  locale: LOCALES,
  catalogType: keyof NonNullable<ClientConfig["bloomReachPixel"]>,
): string =>
  String(AzureConfigurator.getConfig(locale)?.bloomReachPixel?.[catalogType]);
